import BaseService from "@/js/core/BaseService";
import { ExpertiseEndpoints } from "./ExpertiseEndpoints";

export default class ExpertiseService extends BaseService {
	async fetchExpertises() {
		return this.api().get(ExpertiseEndpoints.FetchExpertises);
	}
}
